var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntegrationIcon04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 46,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50.014%",
    cy: "54.715%",
    fx: "50.014%",
    fy: "54.715%",
    r: "71.729%",
    gradientTransform: "matrix(.92431 0 0 1 .038 0)",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB900",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F95D8F",
    offset: "60%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F95353",
    offset: "99.9%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-39.6%",
    y: "-42.9%",
    width: "179.2%",
    height: "185.7%",
    filterUnits: "objectBoundingBox",
    id: "b"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-790 -3592)",
    fill: "url(#a)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.705 14.823A6.588 6.588 0 1 0 23.704 28a6.588 6.588 0 0 0 0-13.176Zm-17.117 0a6.588 6.588 0 1 0 0 13.177 6.588 6.588 0 0 0 0-13.176Zm15.147-8.235a6.589 6.589 0 1 1-13.177 0 6.589 6.589 0 0 1 13.176 0Z",
    opacity: 0.64,
    filter: "url(#b)",
    transform: "translate(799 3601)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.705 3615.823a6.588 6.588 0 1 0-.001 13.176 6.588 6.588 0 0 0 0-13.176Zm-17.117 0a6.588 6.588 0 1 0 0 13.177 6.588 6.588 0 0 0 0-13.176Zm15.147-8.235a6.589 6.589 0 1 1-13.177 0 6.589 6.589 0 0 1 13.176 0Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationIcon04);
export default __webpack_public_path__ + "static/media/integration-icon-04.0adf1cbc2ca7a750e1d34e794c7940af.svg";
export { ForwardRef as ReactComponent };